module.exports = __webpack_public_path__ + "static/media/Intro.f45a1ab3.gif";